import React from 'react';
import { Container, Row, Col, Form, Button, Spinner } from 'react-bootstrap';
import MaterialTable from 'material-table';
import { PatchedPagination } from '../services/PatchedPagination.js';

import {
    getStorage,
    ref,
    uploadBytes,
    list,
    getDownloadURL
} from 'firebase/storage';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import { dateFormatUtil } from '../Utilities';

import Alert from 'react-bootstrap/Alert';
import RestServices from '../services/RestServices.js';


import Modal from 'react-bootstrap/Modal';

import './styles.css';

const columnsFilteredTags = [
    { title: 'Store CP', field: 'Name' },
    { title: 'ProfileUniqeId', field: 'ProfileUniqeId' },
    { title: 'WhatsApp Number', field: 'WhatsAppNumber' },
    { title: 'Email', field: 'EmailId' }
];

class CreateNotifications extends React.Component {
    _isMounted = false;
    state = {
        alert: 0,
        interval: 0,
        PixelDisabled: true,
        WhatsAppDisabled: true,
        BothDisabled: true,
        showFilteredStoreTags: false,
        showFilteredStoreTagsText: 'View details',
        alertMessage: '',
        images: [],
        selectedStoreTags: [],
        FilteredStoreTags: [],
        flag: false,
        selectedImage: '',
        imageIndex: -1,
        title: '',
        message: '',
        messageImg: '',
        selectedFileName:'',
        modalShow: false,
        sendNotifications:'',
        
    };

    async componentDidMount() {
        this._isMounted = true;
        var rows = [];
        this.applyFilter();
        const storage = getStorage();
        const listRef = ref(storage, 'NotificationImages');
        const firstPage = await list(listRef);
        for (let r of firstPage.items) {
            rows.push(r.name);
        }
        await this.setState({ images: rows });
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    
    


    

    handleImageAsFile = (e) => {
        if (this._isMounted) {
            this.setState({ messageImg: '', flag: true });
        }
        const file = e.target.files[0];
        const storage = getStorage();
        const storageRef = ref(storage, 'NotificationImages/' + file.name);

        uploadBytes(storageRef, file).then(async (snapshot) => {
            this.getImageURL(file.name);
            
        });
    };

    getImageURL = (imageName) => {
        if (this._isMounted) {
            this.setState({ messageImg: '',selectedFileName:imageName, flag: true });
        }
        const storage = getStorage();
        if (imageName) {
            getDownloadURL(
                ref(storage, 'NotificationImages/' + imageName)
            ).then((url) => {
                
                if (this._isMounted) {
                    this.setState({ messageImg: url, 
                        flag: false,
                        PixelDisabled: true,
                        WhatsAppDisabled: false,
                        BothDisabled: true });
                }
            });
           
        } else {
            if (this._isMounted) {
                this.setState({ messageImg: '', flag: false });
            }
        }
    };


    ViewFiltered = () => {
        if (this._isMounted) {
            this.setState({
                showFilteredStoreTags: !this.state.showFilteredStoreTags,
                showFilteredStoreTagsText: !this.state.showFilteredStoreTags
                    ? 'Hide Detail'
                    : 'View Detail'
            });
        }
    };

    timer = () => {
        this.setState({ interval: this.state.interval + 1 });
    };

    applyFilter = async () => {
        var bodyData = {
        };

        this.setState({ interval: 0, FilteredStoreTags: '' });
        let interval = setInterval(this.timer, 1000);
        if (this._isMounted) {
            this.setState({ flag: true });
        }
        await RestServices.applyNotificationFilter(
            localStorage.getItem('FirebaseToken'),
            bodyData
        )
            .then((response) => response.json())
            .then((responseData) => {
                 
                clearInterval(interval);
                if (responseData.error) {
                    if (this._isMounted) {
                        this.setState({
                            flag: false,
                            alert: 1,
                            alertMessage: responseData.error
                        });
                    }
                } else {
                        if (this._isMounted) {
                            this.setState({
                                flag: false,
                                FilteredStoreTags: responseData.filteredTags
                            });
                        
                    } else {
                        if (this._isMounted) {
                            this.setState({
                                flag: false,
                                alert: 1,
                                alertMessage: 'No Store found ...'
                            });
                        }
                    }
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({
                        flag: false,
                        alert: 1,
                        alertMessage: err.message
                    });
                }
            });
    };

    sendNotificationsBoth = async () => {
        this.setState({
            sendNotifications: 'Both',
            modalShow: true,
            alert: 0
        });
    };
    sendNotificationsWhatsApp = async () => {
        this.setState({
            sendNotifications: 'WhatsApp',
            modalShow: true,
            alert: 0
        });
    };
    sendNotificationsPixel = async () => {
        this.setState({
            sendNotifications: 'Pixel',
            modalShow: true,
            alert: 0,
        });
    };

    handleClose = () => {
        if (this._isMounted) {
            this.setState({ modalShow: false,
                alert: 0 });
        }
    };

    
    sendNotificationsMessage = async () => {
        if (this.state.title == '') {
            if (this._isMounted) {
                this.setState({
                    flag: false,
                    alert: 1,
                    alertMessage: 'Please enter title',
                    modalShow: false
                });
            }
        }else if ( this.state.message == '') {
            if (this._isMounted) {
                this.setState({
                    flag: false,
                    alert: 1,
                    alertMessage: 'Please enter message',
                    modalShow: false
                });
            }
        } else {

                var bodyData = {
                    messageSendTo: this.state.sendNotifications,
                    FilteredStoreTags: this.state.FilteredStoreTags,
                    title: this.state.title,
                    messageBody: this.state.message,
                    messageImg: this.state.messageImg,
                    DateTime: dateFormatUtil(),
                    CreatedBy: this.props.user.FullName,
                };
            
            if (this._isMounted) {
                this.setState({
                    flag: true,
                    PixelDisabled: true,
                    WhatsAppDisabled: true,
                    BothDisabled: true,
                    alert: 0,
                    
                });
            }

            RestServices.SendNotification(
                localStorage.getItem('FirebaseToken'),
                bodyData
            )
                .then((response) => response.json())
                .then((responseData) => {
                    
                    if (responseData.error) {
                        if (this._isMounted) {
                            this.setState({
                                PixelDisabled: false,
                                WhatsAppDisabled: false,
                                BothDisabled: false,
                                flag: false,
                                alert: 1,
                                alertMessage: responseData.error,
                                modalShow: false
                            });
                        }
                    } else {
                        if (responseData.status) {
                            if (this._isMounted) {
                                this.setState({
                                    flag: false,
                                    alert: 2,
                                    alertMessage: responseData.message,
                                    modalShow: false,
                                    PixelDisabled: true,
                                    WhatsAppDisabled: true,
                                    BothDisabled: true
                                });
                            }
                        } else {
                            if (this._isMounted) {
                                this.setState({
                                    PixelDisabled: false,
                                    WhatsAppDisabled: false,
                                    BothDisabled: false,
                                    flag: false,
                                    alert: 1,
                                    alertMessage: responseData.message,
                                    modalShow: false
                                });
                            }
                        }
                    }
                })
                .catch((err) => {
                    if (this._isMounted) {
                        this.setState({
                            PixelDisabled: false,
                            WhatsAppDisabled: false,
                            BothDisabled: false,
                            flag: false,
                            alert: 1,
                            alertMessage: err.message,
                            modalShow: false
                        });
                    }
                });
        }
    };

    render() {
        return (
            <Container>
                {this.state.flag && <Spinner animation="border" />}
                {this.state.alert === 1 && (
                    <Alert variant="danger">{this.state.alertMessage}</Alert>
                )}

                {this.state.alert === 2 && (
                    <Alert variant="success">{this.state.alertMessage}</Alert>
                )}
                <Row>
                    <Col md={3}>
                        <span> Title: </span>
                    </Col>
                    <Col md={{ span: 6 }}>
                        <Form.Group>
                            <Form.Control
                                type="text"
                                name="title"
                                placeholder="Enter Title"
                                onBlur={(event) => {
                                    this.setState({
                                        title: event.target.value
                                    });
                                }}
                            />
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col md={3}>
                        <span>Message Body: </span>
                    </Col>
                    <Col md={{ span: 6 }}>
                        <Form.Group controlId="exampleForm.ControlTextarea1">
                            <Form.Control
                                type="text"
                                name="message"
                                placeholder="Enter message"
                                onBlur={(event) => {
                                    this.setState({
                                        message: event.target.value
                                    });
                                }}
                                as="textarea"
                                rows="4"
                            />
                        </Form.Group>
                    </Col>
                </Row>

                <Row>
                    <Col md={3}>
                        <span>Upload Image/File: </span>
                    </Col>
                    <Col md={{ span: 9 }}>
                        <Row>
                            <Col md={{ span: 3 }} style={{ paddingTop: '0' }}>
                                
                                <Tooltip title="Upload Images">
                                    <IconButton aria-label="upload">
                                        <label>
                                            <CloudUploadIcon />
                                            <input
                                                type="file"
                                                hidden
                                                accept=".png, .jpg, .gif, .jgeg,.csv,.xls,.xlsx"
                                                onChange={
                                                    this.handleImageAsFile
                                                }
                                            />
                                        </label>
                                    </IconButton>
                                </Tooltip>
                            </Col>
                            <Col md={{ span: 1 }}></Col>
                            <Col md={{ span: 3 }}>
                                {this.state.messageImg !== '' && (<>
                                    <p>{this.state.selectedFileName}</p>
                                    <img
                                        src={this.state.messageImg}
                                        width="150px"
                                    />
                                </>)}
                            </Col>
                        </Row>
                    </Col>
                </Row>

                <hr />
                <Row>
                    <Col>
                        {this.state.FilteredStoreTags.length} Store selected in{' '}
                        {this.state.interval} Sec.
                        {this.state.FilteredStoreTags.length > 0 && (
                            <Button
                                style={{ marginLeft: '1rem' }}
                                variant="info"
                                type="submit"
                                onClick={this.ViewFiltered}
                            >
                                {this.state.showFilteredStoreTagsText}
                            </Button>
                        )}
                    </Col>
                </Row>

                {this.state.showFilteredStoreTags && (
                    <MaterialTable
                        components={{
                            Pagination: PatchedPagination
                        }}
                        title="Selected Store Tags"
                        columns={columnsFilteredTags}
                        data={this.state.FilteredStoreTags}
                        options={{
                            filtering: true,
                            actionsColumnIndex: -1,
                            pageSize: 15,
                            pageSizeOptions: [
                                15,
                                25,
                                50,
                                100,
                                {
                                    value: this.state.FilteredStoreTags.length,
                                    label: 'All'
                                }
                            ]
                        }}
                    />
                )}

                <hr />

                <Row>
                    <Col>
                        Send a message on
                        {/*<Button
                            disabled={this.state.PixelDisabled}
                            style={{ marginLeft: '1rem' }}
                            variant="primary"
                            type="submit"
                            onClick={this.sendNotificationsPixel}
                        >
                            Pixel
                        </Button>
                    */}
                        <Button
                            style={{ marginLeft: '1rem', marginRight: '1rem' }}
                            variant="primary"
                            type="submit"
                            onClick={this.sendNotificationsWhatsApp}
                        >
                            WhatsApp
                        </Button>
                        {/*
                        <Button
                            disabled={this.state.BothDisabled}
                            variant="primary"
                            type="submit"
                            onClick={this.sendNotificationsBoth}
                        >
                            Both
                        </Button>*/}
                    </Col>
                </Row>
                <hr />

                


                    <Modal
                    show={this.state.modalShow}
                    onHide={this.handleClose}
                    backdrop="static"
                    keyboard={false}
                  >
                    <Modal.Header closeButton>
                        <Modal.Title>Please confirm</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p>Are you sure you want to send a text message {this.state.messageImg!='' &&<>and file</>} to {this.state.FilteredStoreTags.length} stores?</p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.handleClose}>
                            Cancel
                        </Button>
                        <Button variant="primary" onClick={this.sendNotificationsMessage}>
                            Confirm
                        </Button>
                     </Modal.Footer>
                </Modal>

            </Container>
        );
    }
}

export default CreateNotifications;
